/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

import { useState } from "react";

import SmartToyIcon from "@mui/icons-material/SmartToy";

import {
    Box,
    checkObjectLength,
    customUseEffect,
    FormControl,
    FormControlLabel,
    MuiAutocomplete,
    MyTextInput,
    Radio,
    RadioGroup,
    Stack,
    Typography
} from "@common";
import { useHostSelector } from "@hooks";
// =========================================================================================================
function CustomAiPrompt({ onModelChange, onCustomPromptChange, customProp = true, ...props }) {

    const aiModels = useHostSelector(
        (state) => state?.openAI?.verifyOpenAI,
    );
    const [promptType, setPromptType] = useState("default");
    const [customPrompt, setCustomPrompt] = useState("");
    const [selectedModel, setSelectedModel] = useState(null);

    const handleModelChange = (value) => {
        setSelectedModel(value);
        onModelChange?.(value);
    };

    const handleCustomPromptChange = (value) => {
        setCustomPrompt(value);
        onCustomPromptChange?.(value);
    };
    customUseEffect(() => {
        if (!selectedModel && aiModels?.length) {
            setSelectedModel(aiModels[0]);
            onModelChange?.(aiModels[0]);
        }
        return () => {
            onModelChange?.(null);
            onCustomPromptChange?.("");
        }
    }, [aiModels]);
    customUseEffect(() => {
        setCustomPrompt("");
        onCustomPromptChange?.("");
    }, [promptType]);
    return (
        <>
            {/* ===== COMPACT AI CONFIGURATION ===== */}
            <Box
                sx={{
                    backgroundColor: "#f9f9fb",
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: 2,
                    marginTop: "1rem"
                }}
            >
                <Stack spacing={2}>
                    {/* Slim Model Selector */}
                    <Box style={{ display: "flex" }} gap={2}>
                        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 0.5 }} minWidth={150}>
                            <SmartToyIcon fontSize="small" color="primary" />
                            <Typography variant="subtitle2" fontWeight={600} sx={{ fontSize: "0.85rem" }}>
                                AI Model
                            </Typography>
                        </Stack>
                        <FormControl fullWidth size="small" variant="outlined">
                            <MuiAutocomplete
                                options={aiModels}
                                label="AI Models"
                                optionValue="name"
                                setValue={(name, newValue) => {
                                    handleModelChange(newValue);
                                }}
                                value={selectedModel}
                                // disableClearable
                                size="small"
                                style={{ marginTop: 0 }}
                                error={!checkObjectLength(selectedModel)}
                                helperText={!checkObjectLength(selectedModel) && "Select the model to continue"}
                            />
                        </FormControl>
                    </Box>

                    {/* Prompt Type Radio Group */}
                    {customProp && (<Box style={{ display: "flex" }} gap={2}>
                        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 0.5 }} minWidth={150}>
                            <SmartToyIcon fontSize="small" color="primary" />
                            <Typography variant="subtitle2" fontWeight={600} sx={{ fontSize: "0.85rem" }}>
                                Prompt Type
                            </Typography>
                        </Stack>
                        <RadioGroup
                            row
                            value={promptType}
                            onChange={(e) => {
                                if (!e.target.value) return
                                setPromptType(e.target.value)
                            }}
                            name="prompt-type-radio"
                        >
                            <FormControlLabel
                                value="default"
                                control={<Radio size="small" />}
                                label={<Typography variant="body2">Default</Typography>}
                            />
                            <FormControlLabel
                                value="custom"
                                control={<Radio size="small" />}
                                label={<Typography variant="body2">Custom</Typography>}
                            />
                        </RadioGroup>
                    </Box>)}

                    {/* Custom Prompt Input (only if 'custom' selected) */}
                    {promptType === "custom" && (<MyTextInput
                        fullWidth
                        multiline
                        minRows={2}
                        maxRows={4}
                        label="Write your custom prompt here…"
                        placeholder="Write your custom prompt here…"
                        value={customPrompt}
                        onChange={(e) => handleCustomPromptChange(e.target.value)}
                        variant="outlined"
                        size="small"
                        fieldLength={3000}
                    />
                    )}
                </Stack>
            </Box>
        </>
    );
}

export default CustomAiPrompt;